import api from './api';
import type { CurrencyCode, CurrencyOption } from '@/constants/currency';

export type CurrencyListPayload = {
  readonly defaultCurrency: CurrencyCode;
  readonly effectiveDate: string | null;
  readonly updatedAt: string | null;
  readonly count: number;
  readonly currencies: ReadonlyArray<CurrencyOption>;
};

export type CurrencyListResponse = {
  readonly data: CurrencyListPayload;
};

export const getSupportedCurrencies = async (): Promise<CurrencyListPayload> => {
  const { data } = await api.get<CurrencyListResponse>('/reference/currencies');
  return data.data;
};
